
import { Vue } from "vue-class-component";

export default class DefaultContentComponent extends Vue {}
